<label [attr.for]="forId || null" [ngClass]="labelClass">
    <span>{{ labelKey | translate }}</span>
    <span *ngIf="required" class="ms-0.5 text-red-600" aria-hidden="true">*</span>
    <span *ngIf="optional" class="ms-1 text-sm font-normal text-disabled">({{ 'common.optional' | translate }})</span>
</label>
